$bog_fragile_demo_rename_base2 $mol_view
	caption \База
	sub / <= caption
